export default {
  disabled: {
    title: 'Laskutusta ei hallita alustalla',
    description:
      'Tilaukset ja laskut eivät ole käytettävissä, koska sinun ja ravintoloidesi välinen laskutus hoidetaan alustan ulkopuolella. Tilitykset, tiliotteet ja raportit ovat yhä käytettävissä.',
  },
};
